import React from "react";
import classNames from "classnames";

import styles from "./Sidebar.css";

export default function Sidebar({ children, className }) {
  return (
    <div role="complementary" className={classNames(styles.root, className)}>
      {children}
    </div>
  );
}
